export default {
    inserted(element, binding, vnode) {
        if (vnode.tag === 'a' && typeof vnode.data.attrs.href !== 'undefined') {
            element.href = 'mailto:' + vnode.data.attrs.href;
        }
    },
}